import React, { useMemo, type ReactNode } from 'react';
import { AbilityProvider } from '@casl/react';

import { useUserContext } from '../user';
import { useWorkspaceContext } from '../workspace';

import ability from './ability';
import { AbilityContext } from './context';
interface AbilityContextProviderProps {
  children: ReactNode;
}

const AbilityContextProvider = ({ children }: AbilityContextProviderProps) => {
  const { userSession } = useUserContext();
  const { workspace: { defaultWorkspace, tasks, allTasks } } = useWorkspaceContext();

  const abilityValue = useMemo(() => (
    ability(defaultWorkspace, userSession, tasks, allTasks)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ), [defaultWorkspace, userSession, tasks]);

  return (
    <AbilityContext.Provider value={abilityValue}>
      <AbilityProvider value={abilityValue}>
        {children}
      </AbilityProvider>
    </AbilityContext.Provider>
  );
};
export default AbilityContextProvider;
